import * as React from 'react';
import successTick from '@common/bw-ui/icons/animations/successTick.json';
import { AnimatedStateIcon } from '@common/bw-ui/icons/animatedStateIcon';
import { SuccessCircleIcon } from '@common/bw-ui/icons/SuccessCircleIcon';

/**
 * Animated counterpart to {@link SuccessCircleIcon} for validated form fields:
 * the tick draws on once and holds. Falls back to the static icon on the
 * server and under reduced motion.
 */
export function SuccessCircleAnimatedIcon(
  props: Omit<
    React.ComponentProps<typeof AnimatedStateIcon>,
    'animationData' | 'fallback'
  >,
) {
  return (
    <AnimatedStateIcon
      animationData={successTick}
      fallback={SuccessCircleIcon}
      {...props}
    />
  );
}
